import { Col, Container, Row } from 'react-bootstrap';
import OutlinedCard from './OutlinedCard';

const cardData = [
  {
    title: 'Health Care FSA',
    totalPrice: 2000,
    availablePrice: 399.75,
    yearlyPrice: 1750.75,
  },
  {
    title: 'Dependent Care FSA',
    totalPrice: 5000,
    availablePrice: 2056,
    yearlyPrice: 2750,
  },
];

const OutlinedCardDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Outlined Card</h4>
        <Container className="pb-10">
          <Row>
            <Col lg={4}>
              <OutlinedCard cardData={cardData[0]} />
            </Col>
            <Col lg={4}>
              <OutlinedCard cardData={cardData[1]} />
            </Col>
          </Row>
        </Container>
      </Container>
    </Container>
  );
};

export default OutlinedCardDemo;
